import { app } from '../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.reports-session-recording', {
        url: '/reports/sessionrecording',
        component: 'sessionRecordingReport',
    });
}


// WEBPACK FOOTER //
// ./src/portal/states/company/reports/session-recording-report/session-recording-report.state.js